// VehTypeGroupOrderDict.js
// DbdbTap 2024-08-20 17:56:36
import { InputType, TableColumnType } from "../../value/AppConst";
import ValueMisc from "../../value/ValueMisc";

const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    vehTypeId : {
        id: 'vehTypeId',
        type: InputType.text, required: true, toAdd: true, toEdit: true,
    },
    vehTypeGpCd : {
        id: 'vehTypeGpCd',
        type: InputType.text, required: true, toAdd: true, toEdit: true,
	},
    vehOrder : {
        id: 'vehOrder',
        type: InputType.number, required: false, toAdd: true, toEdit: true,
    },
    
};

const ColumnsInMinimal = [
    { id: 'vehTypeName', label: '차종', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
    { id: 'vehOrder', label: '순번', width: 40, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
    { id: 'loadCapaText', label: '적재용량', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
    { id: 'freshCargo', label: '신선차량여부', width: 120, show: true, option:{align: 'center', print:(r,i,v)=>v?'신선':'-'} },
];


const inTableProps = {
    tableId: 'vehTypeGroupOrderTable',
    //inTableId: 'vehTypeGroupOrderInTable',
    //outTableId: 'vehTypeGroupOrderOutTable',
    uniqueKey: 'vehTypeId',
    flexOption: {
        multiChecker:false,
        hideFirstTopButton: false,
        hideColumnConfig: true,
        growToFill: true,
        noSorting: true,
    },
};

const outTableProps = {
    tableId: 'vehTypeGroupOrderOutTable',
    uniqueKey: 'vehTypeId',
    flexOption: {
        multiChecker:false,
        hideFirstTopButton: false,
        hideColumnConfig: true,
        growToFill: true,
        noSorting: false,
    },
    columns: [
        //print using getTableColumnOption(c,t,i)
        { id: 'vehTypeName', label: '차종', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        { id: 'freshCargo', label: '신선차량여부', width: 120, show: true, option:{align: 'center', print:(r,i,v)=>v?'신선':'-'} },
        { id: 'loadCapaText', label: '적재용량', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
    ]
};

/**
 * VEH_TYPE_GROUP_ORDER React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-08-20 17:56:36 using DbdbTap
 */
export const VehTypeGroupOrderDictionary = {
    inputMap: Dict,
    errorTitle: {
        Map: '차종 추가 오류',
        Order: '순서 변경 오류',
        Remove: '차종 삭제 오류',
        Get: '차종설정 조회 오류',
    },
    tableProps: {
        ...inTableProps,
        columns: [
            ...ColumnsInMinimal,
            { id: 'regDate', label: "등록일", width: 120, show: true, option:{align: 'inherit', print:(r,i,v)=>ValueMisc.substr(v,0,10)} },
            { id: 'userName', label: "등록자", width: 80, show: true, option:{align: 'inherit', print:(r,i,v)=>v || r.regUser} },
        ]
    },
    inTableProps: {
        ...inTableProps,
        tableId: 'vehTypeGroupOrderInTable',
        columns: ColumnsInMinimal,
    },
    outTableProps: outTableProps,
};
